import { PremiumStoreApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
export const SALE_PRODUCT_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
export const getIsOnSale = async _ref => {
  let httpClient = _ref.httpClient;
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    domainsLogger = _await$import$Domains.domainsLogger;
  try {
    var _ref2, _saleDetails$saleType;
    const _PremiumStoreApiClien = PremiumStoreApiClient.queries({
        httpClient
      }),
      getSale = _PremiumStoreApiClien.getSale;
    const _await$getSale = await getSale({
        productTypeId: SALE_PRODUCT_ID
      }),
      saleDetails = _await$getSale.saleDetails;
    return {
      saleDetails,
      isOnSale: (_ref2 = ['SEASONAL', 'PERSONAL']) == null ? void 0 : _ref2.includes((saleDetails == null || (_saleDetails$saleType = saleDetails.saleType) == null ? void 0 : _saleDetails$saleType.toUpperCase()) ?? '')
    };
  } catch (error) {
    domainsLogger({
      error: error,
      stack: error.stack,
      type: 'error',
      entity: 'getIsOnSale'
    });
    return {
      saleDetails: undefined,
      isOnSale: false
    };
  }
};
//# sourceMappingURL=getIsOnSale.js.map